import { AxiosInstance } from "axios";
import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { DistrictListRequestBody, DistrictListResponse } from "./types";

export class DistrictListAPI extends BaseAPI<
  DistrictListRequestBody,
  DistrictListResponse
> {
  protected route = ApiRoutes.property.district;
  protected method = RequestMethod.GET;

  constructor(axios: AxiosInstance, city_id: string) {
    super(axios);
    this.route = ApiRoutes.property.district.replace("{city_id}", city_id);
  }
}
